import { required, validateEmail } from "@web/components/Forms"
import TomboForm from "@web/components/Tombo/Form/Form"
import TomboHomepageLayout from "@web/components/Tombo/Layout/Layout"

const ApplyDataLabeler = () => {
  return (
    <TomboHomepageLayout>
      <TomboForm
        fields={[
          { name: "email", label: "Email", component: "TextField", rules: { required: true, validate: validateEmail } },
          { name: "linkedin", label: "LinkedIn Url", component: "TextField", rules: { required: true } },
          {
            name: "message",
            label: "Your Message",
            component: "TextField",
            multiline: true,
            rules: { required: true },
          },
        ]}
        title="Apply As Data Labeler"
        onSubmit={() => {
          alert("OK")
        }}
      />
    </TomboHomepageLayout>
  )
}
export default ApplyDataLabeler
